export const formatPhone = (phoneNumber: string | undefined) => {
  if (!phoneNumber) return ''
  const digits = phoneNumber.replace(/\D/g, '')
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
  }
  return phoneNumber
}
